
export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-green-700 to-green-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
          <p className="text-xl text-green-100">
            Last updated: December 15, 2024
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Agreement to Terms</h2>
              <p className="text-gray-600 mb-4">
                By accessing and using AyurVeda's website and services, you accept and agree to be bound by the terms and provision of this agreement. 
                If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Use License</h2>
              <p className="text-gray-600 mb-4">
                Permission is granted to temporarily download one copy of the materials on AyurVeda's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to reverse engineer any software contained on the website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
              </ul>
              <p className="text-gray-600 mb-4">
                This license shall automatically terminate if you violate any of these restrictions and may be terminated by AyurVeda at any time.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Product Information and Orders</h2>
              <h3 className="text-lg font-semibold text-gray-700 mb-3">Product Descriptions</h3>
              <p className="text-gray-600 mb-4">
                We strive to provide accurate product descriptions and pricing. However, we do not warrant that product descriptions or other content is accurate, complete, reliable, or current. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.
              </p>
              
              <h3 className="text-lg font-semibold text-gray-700 mb-3">Order Acceptance</h3>
              <p className="text-gray-600 mb-4">
                All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order for any reason, including but not limited to:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Product availability</li>
                <li>Errors in product or pricing information</li>
                <li>Suspected fraudulent transactions</li>
                <li>Violation of these Terms of Service</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Health Disclaimers</h2>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
                <p className="text-yellow-800 font-semibold">Important Health Notice</p>
              </div>
              <p className="text-gray-600 mb-4">
                The information and products on this website are not intended to diagnose, treat, cure, or prevent any disease. Ayurvedic products and recommendations are based on traditional practices and are not evaluated by the FDA.
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Always consult with a qualified healthcare provider before starting any new supplement regimen</li>
                <li>Pregnant or nursing mothers should consult their healthcare provider before use</li>
                <li>Discontinue use and consult your doctor if any adverse reactions occur</li>
                <li>Keep all products out of reach of children</li>
                <li>Individual results may vary</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Payment and Pricing</h2>
              <p className="text-gray-600 mb-4">
                All prices are listed in USD and are subject to change without notice. Payment is due at the time of order placement. We accept major credit cards and other payment methods as indicated on our website.
              </p>
              <p className="text-gray-600 mb-4">
                You agree to provide current, complete, and accurate payment information for all purchases. You are responsible for all charges incurred under your account.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">6. Shipping and Delivery</h2>
              <p className="text-gray-600 mb-4">
                Shipping costs and delivery times vary based on location and shipping method selected. Delivery times are estimates and not guaranteed. Risk of loss and title for products pass to you upon delivery to the carrier.
              </p>
              <p className="text-gray-600 mb-4">
                We are not responsible for delays caused by shipping carriers, weather conditions, or other circumstances beyond our control.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">7. Returns and Refunds</h2>
              <p className="text-gray-600 mb-4">
                We want you to be satisfied with your purchase. Our return policy includes:
              </p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>30-day return window from date of delivery</li>
                <li>Products must be unopened and in original condition</li>
                <li>Return shipping costs are the responsibility of the customer unless the return is due to our error</li>
                <li>Refunds will be processed within 5-7 business days after receiving returned items</li>
                <li>Certain products may be non-returnable for health and safety reasons</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">8. User Accounts</h2>
              <p className="text-gray-600 mb-4">
                When you create an account with us, you must provide information that is accurate, complete, and current. You are responsible for safeguarding your account credentials and for all activities under your account.
              </p>
              <p className="text-gray-600 mb-4">
                We reserve the right to suspend or terminate accounts that violate these terms or engage in fraudulent activity.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">9. Intellectual Property</h2>
              <p className="text-gray-600 mb-4">
                The service and its original content, features, and functionality are and will remain the exclusive property of AyurVeda and its licensors. The service is protected by copyright, trademark, and other laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">10. Prohibited Uses</h2>
              <p className="text-gray-600 mb-4">You may not use our service:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>For any unlawful purpose or to solicit others to perform unlawful acts</li>
                <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
                <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
                <li>To harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
                <li>To submit false or misleading information</li>
                <li>To upload or transmit viruses or any other type of malicious code</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">11. Limitation of Liability</h2>
              <p className="text-gray-600 mb-4">
                In no event shall AyurVeda, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the service.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">12. Governing Law</h2>
              <p className="text-gray-600 mb-4">
                These Terms shall be interpreted and governed by the laws of the State of North Carolina, United States, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">13. Changes to Terms</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">14. Contact Information</h2>
              <p className="text-gray-600 mb-4">
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-green-50 p-4 rounded-lg">
                <p className="text-gray-700"><strong>Email:</strong> legal@ayurveda.com</p>
                <p className="text-gray-700"><strong>Phone:</strong> +1 (555) 123-4567</p>
                <p className="text-gray-700"><strong>Address:</strong> 123 Wellness Street, Natural City, NC 12345</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
